import React from 'react';

// Tiny CSS mockups so an editor can see what each section looks like in the Add picker.
// Pure presentational divs styled by .tt-* classes in HomepageBuilder.css.

const card = (k) => <div className="tt-card" key={k} />;
const cardRow = (n, key) => <div className="tt-row" key={key}>{Array.from({ length: n }).map((_, k) => card(k))}</div>;

export default function TemplateThumb({ type }) {
  let body;
  switch (type) {
    case 'slider_banner':
      body = <div className="tt-hero" />;
      break;
    case 'shortcut':
      body = <div className="tt-shortcuts">{Array.from({ length: 5 }).map((_, k) => <div className="tt-dot" key={k} />)}</div>;
      break;
    case 'brand_focus':
      body = <div className="tt-shortcuts">{Array.from({ length: 5 }).map((_, k) => <div className="tt-dot" key={k} />)}</div>;
      break;
    case 'row1_no_bg_card':
      body = <div>{cardRow(4, 0)}</div>;
      break;
    case 'row2_no_bg_card':
      body = <div>{cardRow(4, 0)}{cardRow(4, 1)}</div>;
      break;
    case 'row3':
      body = <div>{cardRow(4, 0)}{cardRow(4, 1)}{cardRow(4, 2)}</div>;
      break;
    case 'banner_chip_2_rows':
      body = <div><div className="tt-banner" /><div className="tt-chips">{Array.from({ length: 4 }).map((_, k) => <div className="tt-chip" key={k} />)}</div>{cardRow(4, 0)}</div>;
      break;
    case 'banner_only':
      body = <div className="tt-banner tt-banner-tall tt-banner-purple" />;
      break;
    case 'break_with_bg':
      body = <div className="tt-banner tt-banner-tall" />;
      break;
    case 'break_without_bg':
      body = <div className="tt-stats"><div className="tt-stat-ic" /><div className="tt-stat-lines"><div className="tt-line" /><div className="tt-line short" /></div></div>;
      break;
    case 'promo_banner':
      body = <div className="tt-banner tt-banner-green" />;
      break;
    default:
      body = <div>{cardRow(4, 0)}</div>;
  }
  return <div className="tt">{body}</div>;
}
